import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(id: number, params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      // If params contains statement, we might need to serialize it or pass it as query param
      // Legacy code: Pdf.get({ id: 351 }, { statement: statement }, ...)
      // This implies statement is sent as query param? Or body?
      // $resource get usually sends params as query params.
      // But statement is a large object.
      // Let's assume it's query params for now, but it might be problematic if too long.
      // However, the legacy definition is: "api/getpdf/:id", { id: "id" }, {}
      // And usage: Pdf.get({ id: 351 }, { statement: statement })
      // This suggests the second argument is query params.
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (typeof value === 'object') {
          httpParams = httpParams.set(key, JSON.stringify(value));
        } else {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<any>(`/api/getpdf/${id}`, { params: httpParams });
  }

  save(id: number, body: any): Observable<any> {
    return this.http.post<any>(`/api/getpdf/${id}`, body);
  }
}
